<app-cargando *ngIf="cargando"></app-cargando>

<div class="row" *ngIf="!cargando">
    <div class="col-12">
        <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3 class="card-title"><i class="fas fa-bars me-2"></i>Administración de Menú</h3>
                <button class="btn btn-primary btn-sm" (click)="abrirCrear(modalEditar)">
                    <i class="fas fa-plus me-1"></i>Crear Menú
                </button>
            </div>

            <div class="card-body p-0">
                <!-- Empty state -->
                <div *ngIf="tree.length === 0" class="text-center text-muted py-5">
                    <i class="fas fa-folder-open fa-3x mb-3 d-block"></i>
                    No hay menús configurados.
                </div>

                <!-- Tree -->
                <div class="menu-tree" cdkDropList (cdkDropListDropped)="dropParent($event)" *ngIf="tree.length > 0">
                    <div *ngFor="let parent of tree; let pi = index" cdkDrag class="menu-parent-item">
                        <!-- Drag preview -->
                        <div *cdkDragPlaceholder class="menu-drag-placeholder"></div>

                        <!-- Parent row -->
                        <div class="menu-row parent-row d-flex align-items-center">
                            <span class="drag-handle me-2" cdkDragHandle title="Arrastra para reordenar">
                                <i class="fas fa-grip-vertical"></i>
                            </span>
                            <button class="btn btn-sm btn-link p-0 me-2 expand-btn"
                                    (click)="toggleExpand(parent)"
                                    *ngIf="parent.children && parent.children.length > 0">
                                <i class="fas" [ngClass]="parent.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                            </button>
                            <span class="menu-icon me-2" *ngIf="!parent.children || parent.children.length === 0" style="width:20px;"></span>
                            <i [class]="parent.ICONO" class="me-2 text-primary"></i>
                            <span class="menu-name flex-grow-1">
                                {{parent.TITULO || parent.MENUs}}
                                <small class="text-muted ms-2" *ngIf="parent.URL">{{parent.URL}}</small>
                            </span>
                            <span class="badge me-2" [ngClass]="parent.ACTIVO ? 'bg-success' : 'bg-secondary'">
                                {{parent.ACTIVO ? 'Activo' : 'Inactivo'}}
                            </span>
                            <span class="badge bg-light text-dark me-2" title="Orden">
                                #{{parent.ORDEN}}
                            </span>
                            <div class="menu-actions">
                                <button class="btn btn-outline-success btn-xs me-1" title="Agregar submenú"
                                        (click)="abrirCrear(modalEditar, parent._id)">
                                    <i class="fas fa-plus"></i>
                                </button>
                                <button class="btn btn-outline-primary btn-xs me-1" title="Editar"
                                        (click)="abrirEditar(modalEditar, parent)">
                                    <i class="fas fa-pencil-alt"></i>
                                </button>
                                <button class="btn btn-outline-danger btn-xs" title="Eliminar"
                                        (click)="eliminar(parent)">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </div>

                        <!-- Children -->
                        <div class="menu-children" *ngIf="parent.expanded && parent.children && parent.children.length > 0"
                             cdkDropList (cdkDropListDropped)="dropChild($event, parent)">
                            <div *ngFor="let child of parent.children; let ci = index" cdkDrag class="menu-child-item">
                                <div *cdkDragPlaceholder class="menu-drag-placeholder child-placeholder"></div>
                                <div class="menu-row child-row d-flex align-items-center">
                                    <span class="drag-handle me-2" cdkDragHandle title="Arrastra para reordenar">
                                        <i class="fas fa-grip-vertical"></i>
                                    </span>
                                    <i [class]="child.ICONO" class="me-2 text-info"></i>
                                    <span class="menu-name flex-grow-1">
                                        {{child.TITULO || child.MENUs}}
                                        <small class="text-muted ms-2" *ngIf="child.URL">{{child.URL}}</small>
                                    </span>
                                    <span class="badge me-2" [ngClass]="child.ACTIVO ? 'bg-success' : 'bg-secondary'">
                                        {{child.ACTIVO ? 'Activo' : 'Inactivo'}}
                                    </span>
                                    <span class="badge bg-light text-dark me-2" title="Orden">
                                        #{{child.ORDEN}}
                                    </span>
                                    <div class="menu-actions">
                                        <button class="btn btn-outline-primary btn-xs me-1" title="Editar"
                                                (click)="abrirEditar(modalEditar, child)">
                                            <i class="fas fa-pencil-alt"></i>
                                        </button>
                                        <button class="btn btn-outline-danger btn-xs" title="Eliminar"
                                                (click)="eliminar(child)">
                                            <i class="fas fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal Crear/Editar -->
<ng-template #modalEditar let-modal>
    <div class="modal-header py-2">
        <h5 class="modal-title"><i class="fas fa-edit me-2"></i>{{editTitle}}</h5>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="modal.dismiss()">&times;</button>
    </div>
    <div class="modal-body">
        <div class="row g-3">
            <div class="col-md-6">
                <label class="form-label">Nombre (MENU) <span class="text-danger">*</span></label>
                <input [(ngModel)]="editItem.MENUs" type="text" class="form-control" placeholder="Nombre del menú">
            </div>
            <div class="col-md-6">
                <label class="form-label">Título</label>
                <input [(ngModel)]="editItem.TITULO" type="text" class="form-control" placeholder="Título visible">
            </div>
            <div class="col-md-6">
                <label class="form-label">Ícono (FontAwesome)</label>
                <div class="input-group">
                    <span class="input-group-text">
                        <i [class]="editItem.ICONO || 'fas fa-circle'"></i>
                    </span>
                    <input [(ngModel)]="editItem.ICONO" type="text" class="form-control" placeholder="fas fa-home">
                </div>
            </div>
            <div class="col-md-6">
                <label class="form-label">URL / Ruta</label>
                <input [(ngModel)]="editItem.URL" type="text" class="form-control" placeholder="/intranet/...">
            </div>
            <div class="col-md-6">
                <label class="form-label">Padre</label>
                <select [(ngModel)]="editItem.PADRE" class="form-select">
                    <option value="">— Ninguno (raíz) —</option>
                    <option *ngFor="let p of parentOptions" [value]="p._id">{{p.TITULO || p.MENUs}}</option>
                </select>
            </div>
            <div class="col-md-3">
                <label class="form-label">Orden</label>
                <input [(ngModel)]="editItem.ORDEN" type="number" class="form-control" min="0">
            </div>
            <div class="col-md-3 d-flex align-items-end">
                <div class="form-check form-switch">
                    <input [(ngModel)]="editItem.ACTIVO" class="form-check-input" type="checkbox" id="chkActivo">
                    <label class="form-check-label" for="chkActivo">Activo</label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer py-2">
        <button type="button" class="btn btn-secondary btn-sm" (click)="modal.dismiss()">Cancelar</button>
        <button type="button" class="btn btn-primary btn-sm" (click)="guardar(modal)">
            <i class="fas fa-save me-1"></i>{{isEditing ? 'Actualizar' : 'Crear'}}
        </button>
    </div>
</ng-template>
